import { z } from 'zod';
// we use this schema to validate external data into the domain
const JwtSchema = z.object({
    payload: z.object({
        displayName: z.string().optional(),
        self: z.string().optional(),
        exp: z.number(),
        offresStageActif: z.boolean().optional(),
        echangesActif: z.boolean().optional(),
        license: z
            .object({
            modules: z.array(z.object({
                href: z.string(),
                expiration: z.date().or(z.string()).optional(),
            })),
        })
            .optional(),
        emails: z.array(z.string()),
        franceConnect: z.boolean().optional(),
        providerId: z.string().optional(),
        dateTimeLastLogin: z.date().or(z.string()).optional(),
    }),
    jwt: z.string(),
});
const StoreTiersSchema = z.object({
    ref: z.string(),
    userId: z.string(),
});
const UserSchema = z.object({
    self: z.string(),
    displayName: z.string(),
    email: z.string(),
    franceConnect: z.boolean().optional(),
    providerId: z.string().optional(),
    dateTimeLastLogin: z.date().or(z.string()).optional(),
});
export { JwtSchema, StoreTiersSchema, UserSchema };
//# sourceMappingURL=jwt.js.map